<template>
  <div class="center-base all" style="min-height: 400px;">
    <h3 class="margin-0">
      <font-awesome-icon icon="headset" />
      Help Center
    </h3>
  </div>
</template>

<script>
export default {
  name: 'HelpCenter'
}
</script>



// WEBPACK FOOTER //
// src/views/Static/HelpCenter.vue